import { Modal, ModalFuncProps } from 'antd';
import React from 'react';
import IconClose from '@/assets/images/icons/icon-close.react.svg?react';
import InfoCircleFill from '@/assets/images/icons/info-circle-fill.react.svg?react';
import RedWarmingCircleFill from '@/assets/images/icons/red-warming-fill.react.svg?react';
import SuccessCircleFill from '@/assets/images/icons/success-circle-fill.react.svg?react';
import WarmingCircleFill from '@/assets/images/icons/warming-fill.max.react.svg?react';
import i18n from '@/i18n';
import styles from '@/presentation/components/modal-msg/index.module.scss';

export enum ModalType {
  INFO = 'info',
  CONFIRM = 'confirm'
}
export enum ModalIconType {
  INFO = 'info',
  SUCCESS = 'success',
  RED_WARNING = 'redWarning',
  WARNING = 'warning',
}

interface IModalMsg extends ModalFuncProps {
  type: ModalType,
  typeIcon?: ModalIconType,
}

export const ModalMsg = (config: IModalMsg) => {
  const icon = {
    [ModalIconType.INFO]: <InfoCircleFill />,
    [ModalIconType.SUCCESS]: <SuccessCircleFill />,
    [ModalIconType.RED_WARNING]: <RedWarmingCircleFill />,
    [ModalIconType.WARNING]: <WarmingCircleFill />,
  };
  Modal[config.type]({
    closable: true,
    icon: config.typeIcon ? icon[config.typeIcon] : undefined,
    closeIcon: <IconClose />,
    className: styles.notify,
    title: i18n.t('温馨提示'),
    cancelText: i18n.t('取消'),
    okText: i18n.t('确定'),
    ...config,
  });
};
